class ProductKit extends HTMLElement {
  constructor() {
    super();
    this.selectedVariants = {};
    this.totalPriceElement = document.querySelector('.price-item.price-item--regular');
    this.totalPriceProductBar = document.querySelector('.product-bar__price');
  }

  connectedCallback() {
    this.swatches = this.querySelectorAll('.swatch');
    this.addToCartButton = this.querySelector('.add-bundle-to-cart');
    this.errorMessageWrapper = this.querySelector('.product-kit-form__error-message-wrapper');
    this.errorMessage = this.querySelector('.product-kit-form__error-message');

    this.setupInitialSelections();
    this.attachEvents();
    this.setupFilter();
  }

  setupInitialSelections() {
    const swatchGroups = this.querySelectorAll('.pr_grid_item');

    swatchGroups.forEach(group => {
      const firstSwatch = group.querySelector('.swatch:not([hidden])');
      if (firstSwatch) {
        this.selectSwatch(firstSwatch, false);
      }
    });

    this.updateTotalPrice();
  }

  attachEvents() {
    this.swatches.forEach(swatch => {
      swatch.addEventListener('click', () => this.selectSwatch(swatch, true));
    });

    if (this.addToCartButton) {
      this.addToCartButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleAddToCart();
      });
    }
  }

  setupFilter() {
    const filterButtons = this.querySelectorAll('.filter-button');
    if (!filterButtons.length) return;

    filterButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        filterButtons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        const selectedTamanho = btn.dataset.tamanho;
        this.filterSwatchesByTamanho(selectedTamanho);
      });
    });

    // Ativar o primeiro filtro por padrão
    //filterButtons[0].click();
  }

  filterSwatchesByTamanho(tamanho) {
    const swatches = this.querySelectorAll('.pr_grid_item[data-group="mochila"] .swatch');
    swatches.forEach(swatch => {
      if (swatch.dataset.tamanho === tamanho) {
        swatch.hidden = false;
      } else {
        swatch.hidden = true;
      }
    });

    const visibleSwatch = this.querySelector('.pr_grid_item[data-group="mochila"] .swatch:not([hidden])');
    if (visibleSwatch) {
      this.selectSwatch(visibleSwatch, false);
    }
  }

  selectSwatch(swatch, isUserClick = false) {
    const group = swatch.closest('.pr_grid_item');
    group.querySelectorAll('.swatch').forEach(s => s.classList.remove('active'));
    swatch.classList.add('active');

    const variantId = swatch.dataset.productId;
    group.dataset.variantId = variantId;

    if (isUserClick && swatch.dataset.image) {
      const imgEl = document.querySelector('.product__media-item.is-active .product__media img');
      if (imgEl) {
        imgEl.src = swatch.dataset.image;
        imgEl.srcset = swatch.dataset.image;
      }
    }

    this.updateTotalPrice();
  }

  updateTotalPrice() {
    let total = 0;

    const selectedGroups = this.querySelectorAll('.pr_grid_item[data-variant-id]');
    selectedGroups.forEach(group => {
      const variantId = group.dataset.variantId;
      const selectedSwatch = group.querySelector(`.swatch[data-product-id="${variantId}"]`);

      if (selectedSwatch && selectedSwatch.dataset.price) {
        total += parseFloat(selectedSwatch.dataset.price) / 100;
      }
    });

    if (this.totalPriceElement) {
      this.totalPriceElement.textContent = this.formatMoney(total);
    }
    if (this.totalPriceProductBar) {
      this.totalPriceProductBar.textContent = this.formatMoney(total);
    }
  }

  formatMoney(amount) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(amount);
  }

  getItems() {
    const items = [];
    const selectedGroups = this.querySelectorAll('.pr_grid_item[data-variant-id]');
    selectedGroups.forEach(group => {
      items.push({
        id: group.dataset.variantId,
        quantity: 1,
        properties: {
          _product_type: this.dataset.productType
        }
      });
    });
    return items;
  }

  async handleAddToCart() {
    // --- INÍCIO: Validação de Restrição de Carrinho ---
    this.RESTRICTED_TYPES = ['Material', 'Uniforme'];
    this.RESTRICTION_ERROR_MESSAGE = '<h4>Você só pode comprar um tipo de benefício por vez: Uniforme ou Material Escolar</h4><p>Finalize a compra atual ou remova os itens do carrinho para comprar este produto.</p>';
    const productTypeToAdd = this.addToCartButton.getAttribute('data-product-type');

    if (productTypeToAdd && this.RESTRICTED_TYPES.includes(productTypeToAdd)) {
      this.addToCartButton.setAttribute('aria-disabled', true);
      this.addToCartButton.classList.add('loading');
      if (this.querySelector('.loading__spinner')) this.querySelector('.loading__spinner').classList.remove('hidden');

      try {
        const cartResponse = await fetch('/cart.js');
        if (!cartResponse.ok) throw new Error('Falha ao buscar carrinho');
        const cart = await cartResponse.json();

        let existingRestrictedType = null;
        if (cart.item_count > 0) {
          for (const item of cart.items) {
            if (
              item.properties &&
              item.properties._product_type &&
              this.RESTRICTED_TYPES.includes(item.properties._product_type)
            ) {
              existingRestrictedType = item.properties._product_type;
              break;
            }
          }
        }

        if (existingRestrictedType && existingRestrictedType !== productTypeToAdd) {
          this.handleMultiCategoryErrorMessage(this.RESTRICTION_ERROR_MESSAGE);
          this.error = true;
          this.addToCartButton.classList.remove('loading');
          this.addToCartButton.removeAttribute('aria-disabled');
          if (this.querySelector('.loading__spinner')) this.querySelector('.loading__spinner').classList.add('hidden');
          console.warn('Adição ao carrinho bloqueada: tipos conflitantes.');
          return;
        } else {
          this.addToCartButton.classList.remove('loading');
          this.addToCartButton.removeAttribute('aria-disabled');
        }

      } catch (error) {
        console.error('Erro ao validar restrição do carrinho:', error);
        this.handleError('Erro ao verificar o carrinho. Tente novamente.');
        this.error = true;
        this.addToCartButton.classList.remove('loading');
        this.addToCartButton.removeAttribute('aria-disabled');
        if (this.querySelector('.loading__spinner')) this.querySelector('.loading__spinner').classList.add('hidden');
        return;
      }
    }
    // --- FIM: Validação de Restrição de Carrinho ---

    const cartDrawer = document.querySelector('cart-drawer');
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    const formData = { items: this.getItems() };

    if (cartDrawer) {
      formData.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
      formData.sections_url = window.location.pathname;
      cartDrawer.setActiveElement(this.addToCartButton);
    }

    config.body = JSON.stringify(formData);

    try {
      const response = await fetch(routes.cart_add_url, config);
      const result = await response.json();

      if (result.status) {
        this.handleError(result.description);
      } else {
        cartDrawer.renderContents(result);
        cartDrawer.classList.remove('is-empty');
      }
    } catch (e) {
      console.error(e);
    }
  }

  handleMultiCategoryErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;

    this.errorMultiCategoryMessageWrapper =
      this.errorMultiCategoryMessageWrapper || this.querySelector('.product-multi-category__error-message-wrapper');
    if (!this.errorMultiCategoryMessageWrapper) return;
    this.errorMessage = this.errorMultiCategoryMessageWrapper.querySelector('.product-multi-category__error-message');

    this.errorMultiCategoryMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.innerHTML = errorMessage;
    }

    this.errorMultiCategoryMessageWrapper.querySelector('.alert__multi-category-close').addEventListener('click', () => {
      this.errorMultiCategoryMessageWrapper.toggleAttribute('hidden', true);
    });
  }

  handleError(message) {
    if (!this.errorMessageWrapper) return;
    this.errorMessageWrapper.hidden = !message;
    if (message && this.errorMessage) {
      this.errorMessage.textContent = message;
    }
  }
}

class ProductKitRecommended extends ProductKit {
  constructor() {
    super();
  }

  handleAddToCart() {
    const cartDrawer = document.querySelector('cart-drawer');
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    const formData = { items: this.getItems() };

    if (cartDrawer) {
      formData.sections = cartDrawer.getSectionsToRender().map((s) => s.id);
      formData.sections_url = window.location.pathname;
      cartDrawer.setActiveElement(this.addToCartButton);
    }

    config.body = JSON.stringify(formData);

    fetch(routes.cart_add_url, config)
      .then(res => res.json())
      .then(data => {
        if (data.status) {
          this.handleError(data.description);
        } else {
          const recommendedKits = document.querySelector('recommended-kits');
          recommendedKits.loadProductByIndex(recommendedKits.currentIndex + 1, data);
        }
      })
      .catch(console.error);
  }
}

class RecommendedKits extends HTMLElement {
  constructor() {
    super();
    this.handles = JSON.parse(sessionStorage.getItem('kitSuggestions') || '[]');
    this.currentIndex = 0;
  }

  connectedCallback() {
    if (!Array.isArray(this.handles) || this.handles.length === 0) return;

    this.linkList = this.querySelector('#kit-links');
    this.contentDiv = this.querySelector('#kit-content');
    this.renderLinks();
    this.loadProductByIndex(0);
  }

  renderLinks() {
    this.handles.forEach((handle, index) => {
      const liElement = document.createElement('li');
      const aElement = document.createElement('a');
      aElement.href = '#';
      aElement.textContent = 'Kit ' + (index + 1);
      aElement.dataset.handle = handle;
      if (index === 0) liElement.classList.add('active');

      aElement.addEventListener('click', (e) => {
        e.preventDefault();
        this.loadProductByIndex(index);
      });

      liElement.appendChild(aElement);
      this.linkList.appendChild(liElement);
    });
  }

  loadProductByIndex(index, previousResponse = null) {
    if (index >= this.handles.length) {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && previousResponse) {
        cartDrawer.renderContents(previousResponse);
        cartDrawer.classList.remove('is-empty');
      }
      return;
    }

    this.currentIndex = index;
    const handle = this.handles[index];

    this.querySelectorAll('#kit-links li').forEach(el => el.classList.remove('active'));
    const activeLi = this.querySelector(`#kit-links a[data-handle="${handle}"]`)?.closest('li');
    if (activeLi) activeLi.classList.add('active');

    this.loadProduct(handle);
  }

  async loadProduct(handle) {
    try {
      const res = await fetch(`/products/${handle}`);
      if (!res.ok) throw new Error('Produto não encontrado');
      const html = await res.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const mainContent = doc.querySelector('#MainContent');

      if (mainContent) {
        this.contentDiv.innerHTML = mainContent.innerHTML;

        const kitProduct = this.contentDiv.querySelector('kit-product');
        if (kitProduct && typeof kitProduct.connectedCallback === 'function') {
          kitProduct.connectedCallback();
        }
      } else {
        this.contentDiv.innerHTML = '<p>Conteúdo principal não encontrado.</p>';
      }
    } catch (err) {
      this.contentDiv.innerHTML = `<p>Erro ao carregar o produto: ${handle}</p>`;
      console.error(err);
    }
  }
}

if (document.querySelector('#kit-suggestions')) {
  if (!customElements.get('product-kit')) {
    customElements.define('product-kit', ProductKitRecommended);
  }
} else {
  if (!customElements.get('product-kit')) {
    customElements.define('product-kit', ProductKit);
  }
}

if (!customElements.get('recommended-kits')) {
  customElements.define('recommended-kits', RecommendedKits);
}